module.exports = __webpack_public_path__ + "img/bangladesh_icc.abed9c7a.png";